import { Box } from 'edenred-ui';
import styled from 'styled-components';

import MuiPaper from '@mui/material/Paper';

export const ModalTitle = styled(Box)`
  font-size: ${({ theme }) => theme.fontSize};
  font-weight: ${({ theme }) => theme.fontBold};
`;

export const ModalMessage = styled(Box)`
  font-size: ${({ theme }) => theme.fontSize};
  margin: 24px 0;
`;

export const SemiBold = styled.span`
  font-weight: ${({ theme }) => theme.fontSemiBold};
`;

export const DialogWidth = styled(MuiPaper)`
  max-width: 650px;
`;
